define.alias("ember-cli-string-helpers/helpers/camelize", "calendar/helpers/camelize");